import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { forusEventsApi } from 'api';
import { useAuth } from 'components/context/AuthContext';
import '../../vendor/forus/engine.js'; // setea window.FX
import '../../vendor/forus/xlsx.js';   // setea window.XLSX_LITE
import './ForusEventsPanel.css';
import OBJ_HOURLY from './obj_hourly.json'; // objetivo de venta por marca/fecha/hora (UYU)
import AA_HOURLY from './aa_hourly.json';   // venta 2025 (año anterior) por marca/fecha/hora (UYU sin IVA), Excel de Forus

// Fechas reales del calendario Forus. MTD = mes en curso (data real). Los eventos son de
// noviembre: hasta que arranquen, 0. Ventana = unión entre marcas (las fechas varían por marca).
const PERIODS = {
  MTD: { desde: '2026-10-01', hasta: '2026-10-27' },
  PRE: { desde: '2026-10-29', hasta: '2026-11-01' },
  CYBER: { desde: '2026-11-02', hasta: '2026-11-04' },
  Extendimos: { desde: '2026-11-05', hasta: '2026-11-09' },
  BLACK: { desde: '2026-11-27', hasta: '2026-11-30' },
};
const FETCH_DESDE = '2026-10-01';
const FETCH_HASTA = '2026-11-30';
const FORUS_ORG_ID = 1577; // org de Forus en ch3 (la que pide un admin para ver este panel)

// Objetivos Cyber (PRE+CYBER, Jue 29/10 → Mié 4/11). Por marca/fecha: [venta UYU, crecimiento].
// venta = target que comparten ellos; crecimiento = su "target de crecimiento" por día → se
// aplica a las sesiones/tickets del año anterior (CR objetivo = CR 2025). Extendimos y Black
// se agregan cuando los pasen.
const OBJ_CYBER = {
  'CAT': { '2026-10-29': [53021, -0.21], '2026-10-30': [196997, 0.949], '2026-10-31': [172973, 1.7295], '2026-11-01': [176001, 1.165], '2026-11-02': [1095724, 0.4667], '2026-11-03': [984740, 0.0599], '2026-11-04': [1394467, 0.2637], '2026-11-05': [118980, 0.72], '2026-11-06': [215261, 0.44], '2026-11-07': [150019, 0.58], '2026-11-08': [292330, 0.36], '2026-11-09': [63947, 0.12] },
  'Columbia': { '2026-10-29': [70669, 2.01], '2026-10-30': [100000, -0.51], '2026-10-31': [100000, -0.32], '2026-11-01': [100000, -0.45], '2026-11-02': [961849, 0.2832], '2026-11-03': [894757, 0.4767], '2026-11-04': [1085940, 0.8775], '2026-11-05': [62867, -0.04], '2026-11-06': [190843, 0.2], '2026-11-07': [127389, 0.2], '2026-11-08': [259465, 0.2], '2026-11-09': [62867, -0.18] },
  'Hush Puppies': { '2026-10-29': [25000, -0.62], '2026-10-30': [180263, 0.28], '2026-10-31': [216229, 0.19], '2026-11-01': [166165, 0.1871], '2026-11-02': [665162, 0.1871], '2026-11-03': [707512, 0.1871], '2026-11-04': [1383819, 0.1871], '2026-11-05': [210849, 0.19], '2026-11-06': [161585, 0.19], '2026-11-07': [156344, 0.19], '2026-11-08': [210611, 0.19], '2026-11-09': [203826, 0.19] },
  'Mango': { '2026-10-29': [90148, 0.25], '2026-10-30': [120000, 0.44], '2026-10-31': [180000, 0.74], '2026-11-01': [300000, 0.65], '2026-11-02': [884012, 0.24], '2026-11-03': [762204, 0.24], '2026-11-04': [1099680, 0.24], '2026-11-05': [52373, -0.55], '2026-11-06': [274956, 1.38], '2026-11-07': [189850, 1.44], '2026-11-08': [340421, -0.24], '2026-11-09': [72012, 11.59] },
  'Merrell': { '2026-10-29': [215725, 16.33], '2026-10-30': [263395, 1.36], '2026-10-31': [272085, 1.38], '2026-11-01': [235893, 0.16], '2026-11-02': [905717, 0.3201], '2026-11-03': [1028230, 0.2993], '2026-11-04': [1600000, 0.4423], '2026-11-05': [100551, 1.17], '2026-11-06': [214853, 0.48], '2026-11-07': [177719, 0.48], '2026-11-08': [222381, 0.48], '2026-11-09': [150507, 0.48] },
  'Pasqualini': { '2026-10-29': [10046, 0.1], '2026-10-30': [76556, 0.39], '2026-10-31': [76362, -0.14], '2026-11-01': [64287, 0.09], '2026-11-02': [518847, 0.196], '2026-11-03': [422775, 0.196], '2026-11-04': [550733, 0.196], '2026-11-05': [106293, 0.09], '2026-11-06': [60151, 0.09], '2026-11-07': [47218, 0.17], '2026-11-08': [67936, 0.09], '2026-11-09': [73054, 0.09] },
  'RKF': { '2026-10-30': [81977, 0.52], '2026-10-31': [87833, 0.52], '2026-11-01': [145618, -0.04], '2026-11-02': [409125, 0.1883], '2026-11-03': [333370, 0.4437], '2026-11-04': [434268, 0.0514], '2026-11-05': [117576, 0.86], '2026-11-06': [66535, -0.02], '2026-11-07': [52230, 0.56], '2026-11-08': [75148, -0.2], '2026-11-09': [80808, 0.67] },
  'Under Armour': { '2026-10-29': [202057, -0.24], '2026-10-30': [358489, 0.31], '2026-10-31': [321010, 0.24], '2026-11-01': [380256, 0.05], '2026-11-02': [1425960, 0.28], '2026-11-03': [1782450, 0.11], '2026-11-04': [2970750, 0.72], '2026-11-05': [300295, -0.18], '2026-11-06': [461991, 0.57], '2026-11-07': [382143, 0.54], '2026-11-08': [478179, 0.21], '2026-11-09': [600590, 0.77] },
};
const OBJ_DATES = ['2026-10-29', '2026-10-30', '2026-10-31', '2026-11-01', '2026-11-02', '2026-11-03', '2026-11-04', '2026-11-05', '2026-11-06', '2026-11-07', '2026-11-08', '2026-11-09'];

// Objetivo de % marketing (inversión / venta SIN IVA) por período×marca — lo que marca el cliente
// (Forus). Período del Excel → key del selector: Total Mes → MTD, Extendido → Extendimos. "Resto de
// mes" no tiene equivalente en el selector (se omite). Columbia/Pre sin evento 2025 → 0 (N/A). El
// Actual se calcula también sobre venta sin IVA (÷IVA_UY) para que la comparación sea consistente.
const OBJ_MKT = {
  PRE: { 'CAT': 0.0484, 'Columbia': 0, 'Hush Puppies': 0.0460, 'Mango': 0.0362, 'Merrell': 0.0483, 'Pasqualini': 0.0406, 'RKF': 0.0312, 'Under Armour': 0.0376 },
  CYBER: { 'CAT': 0.0463, 'Columbia': 0.0593, 'Hush Puppies': 0.0354, 'Mango': 0.0423, 'Merrell': 0.0361, 'Pasqualini': 0.0385, 'RKF': 0.0335, 'Under Armour': 0.0298 },
  Extendimos: { 'CAT': 0.0715, 'Columbia': 0.0298, 'Hush Puppies': 0.0677, 'Mango': 0.0519, 'Merrell': 0.0503, 'Pasqualini': 0.0536, 'RKF': 0.0433, 'Under Armour': 0.0474 },
  BLACK: { 'CAT': 0.0354, 'Columbia': 0.0184, 'Hush Puppies': 0.0374, 'Mango': 0.0391, 'Merrell': 0.0527, 'Pasqualini': 0.0364, 'RKF': 0.0486, 'Under Armour': 0.0349 },
  MTD: { 'CAT': 0.0496, 'Columbia': 0.0424, 'Hush Puppies': 0.0429, 'Mango': 0.0497, 'Merrell': 0.0441, 'Pasqualini': 0.0426, 'RKF': 0.0425, 'Under Armour': 0.0353 },
};
// "Resto de mes" (días SIN evento) por marca. Es el fallback: si una marca no tiene %mkt objetivo
// propio en un evento (N/A, ej. Columbia en Pre) o el día no cae en ningún evento, se usa este valor.
const OBJ_MKT_RESTO = { 'CAT': 0.0507, 'Columbia': 0.0377, 'Hush Puppies': 0.0463, 'Mango': 0.0789, 'Merrell': 0.0586, 'Pasqualini': 0.0360, 'RKF': 0.0704, 'Under Armour': 0.0406 };
// % marketing objetivo del DÍA para una marca: según el evento en que cae la fecha (Pre/Cyber/
// Extendido/Black); si la marca no tiene objetivo propio ahí (N/A) o el día no es de evento → Resto
// de mes. El %mkt de una ventana = Σ(venta obj × %mkt del día) ÷ Σ venta obj (lo arma el motor).
const pctMktDia = (marca, fecha) => {
  let ev = null;
  for (const k of ['PRE', 'CYBER', 'Extendimos', 'BLACK']) {
    if (fecha >= PERIODS[k].desde && fecha <= PERIODS[k].hasta) { ev = OBJ_MKT[k] ? OBJ_MKT[k][marca] : null; break; }
  }
  return ev != null && ev > 0 ? ev : (OBJ_MKT_RESTO[marca] || 0);
};
// Descuento Santander (así quiere Forus "importar" la venta de Shopify): a la venta SIN IVA se le
// descuenta el % de la tabla, pero solo sobre el 95% de la venta (participación Santander estimada).
// → venta neta = venta_sin_IVA × (1 − 0,95 × %desc). El % depende de marca × período (Pre Cyber / Activo
// = CYBER / Extendido / Resto del mes). Solo se aplica a la VENTA REAL 2026 (decisión Fran); el año
// anterior y el target quedan brutos sin IVA. UA en "Resto del mes" = sin descuento.
const SANT_PART = 0.95;
const SANT = {
  'CAT':          { PRE: 0.25, CYBER: 0.25, EXT: 0.15, RESTO: 0.15 },
  'Columbia':     { PRE: 0.15, CYBER: 0.25, EXT: 0.15, RESTO: 0.15 },
  'Hush Puppies': { PRE: 0.25, CYBER: 0.25, EXT: 0.15, RESTO: 0.15 },
  'Mango':        { PRE: 0.15, CYBER: 0.15, EXT: 0.15, RESTO: 0.15 },
  'Merrell':      { PRE: 0.25, CYBER: 0.25, EXT: 0.15, RESTO: 0.15 },
  'Pasqualini':   { PRE: 0.25, CYBER: 0.25, EXT: 0.15, RESTO: 0.15 },
  'RKF':          { PRE: 0.25, CYBER: 0.25, EXT: 0.15, RESTO: 0.15 },
  'Under Armour': { PRE: 0.25, CYBER: 0.25, EXT: 0.15, RESTO: 0 },
};
const santPeriodo = (f) => {
  if (f >= PERIODS.PRE.desde && f <= PERIODS.PRE.hasta) return 'PRE';
  if (f >= PERIODS.CYBER.desde && f <= PERIODS.CYBER.hasta) return 'CYBER';
  if (f >= PERIODS.Extendimos.desde && f <= PERIODS.Extendimos.hasta) return 'EXT';
  return 'RESTO'; // incluye Black y el resto del mes
};
const santFactor = (marca, f) => {
  const s = SANT[marca];
  if (!s) return 1;
  return 1 - SANT_PART * (s[santPeriodo(f)] || 0);
};

// Filas de objetivo por fecha×marca para el engine. Sesiones/tickets objetivo = los del año
// anterior (misma fecha −364) escalados por el crecimiento; así CR objetivo = CR del año anterior.
function buildObjetivos(shopify) {
  const aa = new Map(); // marca|fecha2025 -> {ses,tk} (incluye GA4-2025 sintético y Shopify 2025)
  for (const r of shopify) {
    if (!is2025(r.fecha)) continue;
    const k = r.marca + '|' + r.fecha;
    const a = aa.get(k) || { ses: 0, tk: 0 };
    a.ses += r.sesiones || 0; a.tk += r.tickets || 0; aa.set(k, a);
  }
  const out = [];
  for (const marca in OBJ_CYBER) {
    for (const fecha of OBJ_DATES) {
      const cell = OBJ_CYBER[marca][fecha];
      if (!cell) continue;
      const [venta, g] = cell;
      const ly = aa.get(marca + '|' + shiftDays(fecha, -364)) || { ses: 0, tk: 0 };
      out.push({ fecha, marca, obj_venta_uyu: venta, obj_sesiones: ly.ses * (1 + g), obj_tickets: ly.tk * (1 + g), obj_inversion_usd: venta * pctMktDia(marca, fecha) });
    }
  }
  return out;
}

const SEC = {
  control: { t: 'Control general', svg: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>' },
  obj: { t: 'Objetivos', svg: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/>' },
  camp: { t: 'Campañas y plataformas', svg: '<line x1="6" y1="20" x2="6" y2="12"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="18" y1="20" x2="18" y2="9"/>' },
  comp: { t: 'Comparativo', svg: '<path d="M8 3 4 7l4 4"/><path d="M4 7h15"/><path d="M16 21l4-4-4-4"/><path d="M20 17H5"/>' },
  proy: { t: 'Proyección', svg: '<polyline points="3 17 9 11 13 15 21 7"/><polyline points="15 7 21 7 21 13"/>' },
};

const GT = ['Search', 'PMax', 'Demand Gen', 'Shopping'];
const MT = ['Advantage AO', 'Advantage+', 'Manual'];
const is2025 = (f) => f < '2026-01-01';
const shiftDays = (iso, n) => { const d = new Date(iso + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
// Corte = ahora en Montevideo (UTC-3 fijo). El engine corta la ventana actual Y el año anterior
// en el mismo punto (misma duración), así el "Año anterior" es del mismo período hasta este corte.
// win() lo clampa: período ya terminado → completo; que no arrancó → vacío (0).
const nowCorte = () => { const m = new Date(Date.now() - 3 * 3600 * 1000); return { fecha: m.toISOString().slice(0, 10), hora: m.getUTCHours() }; };
// Ventana del período seleccionado. "Hoy" = hoy en Montevideo; "Personalizado" = rango a elección.
const periodWin = (period, cd, ch) => {
  if (period === 'Hoy') { const t = nowCorte().fecha; return { desde: t, hasta: t }; }
  if (period === 'Personalizado') return { desde: cd, hasta: ch };
  return PERIODS[period];
};
const PERIOD_KEYS = ['Hoy', ...Object.keys(PERIODS), 'Personalizado'];
const canon = (canal, tipo) => {
  const t = (tipo || '').trim();
  if (GT.includes(t)) return ['Google', t];
  if (MT.includes(t)) return ['Meta', t];
  return null;
};

// Nota: cada período usa su ventana global (PERIODS) para TODAS las marcas — el cliente quiere ver
// las 8 en cada evento aunque no todas arranquen el mismo día. (Antes se enmascaraba por marca.)

function buildSrc(raw, tc) {
  // Venta SIN IVA (con envío) en TODO el panel. Shopify 2026 = bruto − IVA real (iva_uyu, lo guarda
  // el conector). GA4-2025 (sintético, sin desglose de impuesto) = aprox bruto ÷ IVA_UY. Precios
  // Shopify son IVA-incluido. Antes de que el conector backfillee el IVA, iva_uyu viene null → resta 0
  // (transitorio: venta = bruto hasta el backfill).
  const shopify = raw.shopify.map((r) => {
    let ing = (r.ingresos_uyu || 0) - (r.iva_uyu || 0);           // sin IVA
    if (!is2025(r.fecha)) ing *= santFactor(r.marca, r.fecha);    // descuento Santander: solo venta real 2026
    const base = { ...r, ingresos_uyu: ing };
    const k = canon(r.canal, r.tipo_campana);
    return k ? { ...base, canal: k[0], tipo_campana: k[1] } : { ...base, canal: 'directo', tipo_campana: '' };
  });
  // Marcas con AA real de Shopify 2025 (ej. Mango: en nov-2025 ya estaba en Shopify pero GA4 no
  // estaba conectado, su AA se trae de Shopify sin IVA exacto). Para esas no se empuja el GA4-2025
  // sintético (evita duplicar el año anterior); el resto sí usa GA4-2025 ≈ bruto ÷ IVA_UY.
  const shop2025 = new Set(raw.shopify.filter((r) => is2025(r.fecha)).map((r) => r.marca));
  for (const r of raw.ga4) {
    if (is2025(r.fecha) && !shop2025.has(r.marca)) {
      shopify.push({ marca: r.marca, fecha: r.fecha, hora: r.hora, canal: 'directo', tipo_campana: '', sesiones: r.sesiones, tickets: r.transacciones, ingresos_uyu: r.ingresos_usd * tc / IVA_UY });
    }
  }
  // VENTA del año anterior = la del Excel de Forus (AA_HOURLY: 2025 por marca/fecha/hora, UYU sin IVA),
  // pedido explícito del cliente: en las fechas que trae el Excel (30/10 → 10/11/2025) reemplaza la venta
  // 2025 de GA4/Shopify hora por hora. SOLO la venta: sesiones y tickets 2025 siguen saliendo de GA4/
  // Shopify (así CR 2025 y los objetivos de sesiones no cambian). Fechas fuera del Excel → GA4/Shopify.
  const seenAA = new Set();
  for (const r of shopify) {
    if (!is2025(r.fecha)) continue;
    const arr = AA_HOURLY[r.marca] && AA_HOURLY[r.marca][r.fecha];
    if (!arr) continue;
    const k = r.marca + '|' + r.fecha + '|' + (+r.hora);
    r.ingresos_uyu = seenAA.has(k) ? 0 : (arr[+r.hora] || 0); // si hubiera varias filas en la hora, la venta va en una sola
    seenAA.add(k);
  }
  for (const marca in AA_HOURLY) {
    for (const fecha in AA_HOURLY[marca]) {
      AA_HOURLY[marca][fecha].forEach((v, h) => { // hora con venta en el Excel pero sin fila 2025 → fila nueva (sin sesiones)
        if (v && !seenAA.has(marca + '|' + fecha + '|' + h)) shopify.push({ marca, fecha, hora: h, canal: 'directo', tipo_campana: '', sesiones: 0, tickets: 0, ingresos_uyu: v });
      });
    }
  }
  const ga4 = raw.ga4.filter((r) => !is2025(r.fecha)).map((r) => ({ marca: r.marca, fecha: r.fecha, hora: r.hora, sesiones: r.sesiones, transacciones: r.transacciones, ingresos_uyu: r.ingresos_usd * tc / IVA_UY }));
  // Inversión (USD) → UYU interno (×tc), así todo el dato interno es UYU y el toggle USD/UYU la divide
  // por su tc como a la venta (antes la inversión quedaba fija en USD → ROAS/CPA/inversión mal en UYU).
  const ads = raw.ads.map((r) => ({ ...r, inversion_usd: (r.inversion_usd || 0) * tc }));
  return { ads, shopify, ga4, objetivos: buildObjetivos(shopify), periodos: [], objetivos_roi: [] };
}

// TC de normalización (fijo): convierte GA4-2025 USD→UYU para que TODO el dato interno sea UYU.
const NORM_TC = 41;
// IVA Uruguay (22%). Los precios de Shopify son IVA-incluido (verificado: subtotal + envío = total,
// el IVA va adentro). Todo el panel muestra venta SIN IVA: Shopify 2026 resta el IVA real (iva_uyu);
// GA4-2025 (sin desglose) se aproxima con ÷IVA_UY. Ver buildSrc.
const IVA_UY = 1.22;
// Moneda de display (toggle USD/UYU). tc=41 → divide a USD; tc=1 → muestra UYU nativo. El símbolo
// acompaña. Se setea en el render según el toggle; afecta solo venta/ingresos/inversión (fmt 'usd').
let CUR = { sym: '$', tc: NORM_TC };

const fmtCell = (v, fmt) => {
  if (v == null) return '—';
  switch (fmt) {
    case 'txt': return v;
    case 'usd': return CUR.sym + Math.round(v).toLocaleString('es-UY');
    case 'usd2': return CUR.sym + (+v).toFixed(2);
    case 'uyu': return '$U' + Math.round(v).toLocaleString('es-UY');
    case 'int': return Math.round(v).toLocaleString('es-UY');
    case 'pct': return Math.round(v * 100) + '%';
    case 'pct2': return (v * 100).toFixed(2) + '%';
    case 'x': return (+v).toFixed(1) + 'x';
    case 'pp': return (v >= 0 ? '+' : '') + (v * 100).toFixed(2) + ' pp';
    default: return String(v);
  }
};
const semClass = (r) => (r == null ? '' : r >= 1 ? 'fev-ok' : r >= 0.7 ? 'fev-warn' : 'fev-bad');

function isGroupStart(m, i) {
  if (!m._gs) { m._gs = new Set(); let c = 0; for (const g of m.groups) { m._gs.add(c); c += g.span; } }
  return m._gs.has(i);
}
function dropCols(m, rm) {
  const rmv = new Set(rm), keep = (i) => !rmv.has(i), shift = (i) => i - rm.filter((r) => r < i).length;
  const cols = m.cols.filter((_, i) => keep(i));
  const rows = m.rows.map((r) => {
    const cells = r.cells.filter((_, i) => keep(i));
    let colors; if (r.colors) { colors = {}; for (const k in r.colors) { const ki = +k; if (keep(ki)) colors[shift(ki)] = r.colors[k]; } }
    return { ...r, cells, colors };
  });
  let groups; if (m.groups) { groups = []; let c = 0; for (const g of m.groups) { let s = 0; for (let k = c; k < c + g.span; k++) if (keep(k)) s++; if (s > 0) groups.push({ label: g.label, span: s }); c += g.span; } }
  const out = { cols, rows }; if (groups) out.groups = groups; return out;
}
// Usuarios que NO ven nada de inversión ni % marketing (el usuario "comercial" de Forus). Se identifican
// por la parte local del email (antes de la @), sin importar el dominio. Para ellos se ocultan: en Control
// los grupos Inversión y % marketing + los KPIs de inversión/ROAS; en Objetivos la fila Inversión; en
// Campañas las columnas Inversión/CPS/CPA/ROAS; en Comparativo el bloque Inversión; y lo mismo en el export.
const NO_INV_USERS = ['comercial'];
let HIDE_INV = false; // se setea en el render según el usuario logueado
const INV_COL = /^(inversi[oó]n|presupuesto|% presupuesto|% ?(mkt|marketing)|cps|cpa|roas|roi objetivo|inv\. año anterior)$/i;
const INV_GRP = /inversi|marketing|mkt/i;
function hideInvCols(m) {
  if (!HIDE_INV || !m) return m;
  const byCol = []; for (const g of m.groups || []) for (let k = 0; k < g.span; k++) byCol.push(g);
  const rm = [];
  m.cols.forEach((c, i) => { if ((byCol[i] && INV_GRP.test(byCol[i].label)) || INV_COL.test(String(c.label).trim())) rm.push(i); });
  return rm.length ? dropCols(m, rm) : m;
}
function renderTable(m, sticky) {
  if (!m) return '<div class="fev-empty">Sin datos en este período.</div>';
  let h = '<table' + (sticky ? ' class="fev-sticky"' : '') + '><thead>';
  if (m.groups) h += '<tr class="fev-grp">' + m.groups.map((g) => `<th colspan="${g.span}">${g.label}</th>`).join('') + '</tr>';
  h += '<tr>' + m.cols.map((c, i) => {
    const bs = i > 0 && m.groups && isGroupStart(m, i) ? 'fev-bs' : '';
    const tip = c.tip ? ' fev-th-tip' : '';
    const title = c.tip ? ` title="${String(c.tip).replace(/"/g, '&quot;')}"` : '';
    return `<th class="${(bs + tip).trim()}"${title}>${c.label}</th>`;
  }).join('') + '</tr></thead><tbody>';
  for (const row of m.rows) {
    const cls = row.cls === 'total' ? 'fev-total' : row.cls === 'sub' ? 'fev-sub' : '';
    h += `<tr class="${cls}">` + row.cells.map((v, i) => {
      const col = m.cols[i], co = row.colors && row.colors[i];
      let inner;
      if (co === 'obj') inner = `<span class="fev-sem ${semClass(v)}">${v == null ? '—' : Math.round(v * 100) + '%'}</span>`;
      // 'objv' = % objetivo mostrado como variación (real/obj − 1) pero con color semáforo 70/100 sobre el ratio
      else if (co === 'objv') inner = `<span class="fev-sem ${semClass(v)}">${v == null ? '—' : (v - 1 >= 0 ? '+' : '') + Math.round((v - 1) * 100) + '%'}</span>`;
      // 'objvi' = idem pero para métricas donde MENOS es mejor (% mkt): v = real/obj, muestra real/obj − 1
      // (+20% = gastó 20% de más) y colorea con el ratio invertido (obj/real ≥1 verde, ≥0.7 amarillo).
      else if (co === 'objvi') inner = `<span class="fev-sem ${semClass(v ? 1 / v : null)}">${v == null ? '—' : (v - 1 >= 0 ? '+' : '') + Math.round((v - 1) * 100) + '%'}</span>`;
      else if (co === 'growth') inner = v == null ? '—' : `<span class="${v >= 0 ? 'fev-pos' : 'fev-neg'}">${(v >= 0 ? '+' : '') + Math.round(v * 100)}%</span>`;
      else { inner = fmtCell(v, col.fmt); if (co === 'ly') inner = `<span class="fev-ly">${inner}</span>`; }
      const bs = i > 0 && m.groups && isGroupStart(m, i) ? ' fev-bs' : '';
      const rh = i === 0 ? ' fev-rh' : '';
      return `<td class="${(rh + bs).trim()}">${inner}</td>`;
    }).join('') + '</tr>';
  }
  return h + '</tbody></table>';
}
const panel = (title, mini, inner) => `<div class="fev-panel fev-card"><div class="fev-phead"><h3>${title}</h3>${mini ? `<span class="fev-mini">${mini}</span>` : ''}</div><div class="fev-tw">${inner}</div></div>`;

// Sección Objetivos: una fila por métrica (Venta/Sesiones/CR/Inversión) × 2025 | Target 2026 | Real 2026,
// + % cumplimiento (real/target, semáforo) y % vs 2025. Lee los agregados de tablaMarcas (índices del engine).
function buildObjetivosTable(D, ctx, brand) {
  const tm = window.FX.tablaMarcas(D, ctx);
  const want = brand === 'Todas las marcas' ? 'TOTAL' : brand;
  const r = tm.rows.find((x) => x.cells[0] === want);
  if (!r) return null;
  const c = r.cells; // ses 1/obj 3/AA 5 · cr 7/obj 9/AA 10 · venta 11/obj 13/AA 15 · inv 17/obj 18
  const defs = [
    { label: 'Venta', aa: c[15], tg: c[13], real: c[11], fmt: 'usd' },
    { label: 'Sesiones', aa: c[5], tg: c[3], real: c[1], fmt: 'int' },
    { label: 'CR', aa: c[10], tg: c[9], real: c[7], fmt: 'pct2' },
    { label: 'Inversión', aa: null, tg: c[18] || null, real: c[17], fmt: 'usd' },
  ].filter((d) => !(HIDE_INV && d.label === 'Inversión'));
  const pos = (x) => (x == null || x === 0 ? null : x);
  const rows = defs.map((d) => {
    const tg = pos(d.tg), aa = pos(d.aa);
    return {
      cells: [
        d.label,
        aa == null ? null : fmtCell(aa, d.fmt),
        tg == null ? null : fmtCell(tg, d.fmt),
        d.real == null ? null : fmtCell(d.real, d.fmt),
        tg == null ? null : d.real / tg,
        aa == null ? null : d.real / aa - 1,
      ],
      colors: { 4: 'objv', 5: 'growth' }, // % objetivo como variación (real/target − 1), igual que en Control
    };
  });
  return {
    cols: [
      { label: 'Métrica', fmt: 'txt' }, { label: '2025', fmt: 'txt' }, { label: 'Target 2026', fmt: 'txt' },
      { label: 'Real 2026', fmt: 'txt' }, { label: '% objetivo', fmt: 'txt' }, { label: '% vs 2025', fmt: 'txt' },
    ],
    rows,
  };
}

// Detalle de objetivos por día (gran='day') o por día+hora (gran='hour'): para cada bucket,
// Ingresos/Sesiones/Conversión en 2025 · Objetivo · Real. Objetivo de venta por hora del Excel;
// sesiones/CR objetivo = año anterior × (1+crec). Respeta la ventana por marca de cada una.
// acum=true → cada fila es el acumulado desde el inicio del período (tendencia); acum=false → solo ese
// día/hora (hora x hora: ver si cada hora del evento viene en verde o rojo). Mismas columnas en ambos.
function buildObjDetalle(D, p, brand, gran, tc, acum) {
  const FX = window.FX;
  const brands = brand === 'Todas las marcas' ? D.brands : [brand];
  const byMT = new Map(); // marca|t -> {ses,tk,rev} (incluye 2026 y 2025 sintético)
  for (const r of D.shop) { const k = r.m + '|' + r.t; const e = byMT.get(k) || { ses: 0, tk: 0, rev: 0 }; e.ses += r.ses; e.tk += r.tk; e.rev += r.rev; byMT.set(k, e); }
  const invMT = new Map(); // marca|t -> inversión (Google+Meta, UYU interno), 2026 y 2025
  for (const r of D.ads) { const k = r.m + '|' + r.t; invMT.set(k, (invMT.get(k) || 0) + r.inv); }
  const acc = new Map(), order = [];
  const zz = () => ({ ses: 0, tk: 0, rev: 0, inv: 0 });
  const getE = (k) => { let e = acc.get(k); if (!e) { e = { r: zz(), a: zz(), o: zz() }; acc.set(k, e); order.push(k); } return e; };
  const a0 = FX.dayIdx(p.desde), a1 = FX.dayIdx(p.hasta); // ventana del período para todas las marcas
  for (const b of brands) {
    const oc = OBJ_CYBER[b] || {}, oh = OBJ_HOURLY[b] || {};
    for (let d = a0; d <= a1; d++) {
      const f = FX.dayStr(d), crec = (oc[f] ? oc[f][1] : 0) || 0, objArr = oh[f] || null;
      const pctMkt = pctMktDia(b, f); // inversión objetivo de la hora = venta objetivo de la hora × % mkt del día (= presupuesto del Control, hora a hora)
      for (let h = 0; h < 24; h++) {
        const e = getE(gran === 'hour' ? f + '|' + h : f);
        const real = byMT.get(b + '|' + (d * 24 + h));
        if (real) { e.r.ses += real.ses; e.r.tk += real.tk; e.r.rev += real.rev; }
        const aa = byMT.get(b + '|' + ((d - 364) * 24 + h));
        if (aa) { e.a.ses += aa.ses; e.a.tk += aa.tk; e.a.rev += aa.rev; e.o.ses += aa.ses * (1 + crec); e.o.tk += aa.tk * (1 + crec); }
        if (objArr) { e.o.rev += objArr[h] || 0; e.o.inv += (objArr[h] || 0) * pctMkt; }
        e.r.inv += invMT.get(b + '|' + (d * 24 + h)) || 0;
        e.a.inv += invMT.get(b + '|' + ((d - 364) * 24 + h)) || 0;
      }
    }
  }
  const div = (a, b) => (b ? a / b : null);
  const z = (v) => v || null;
  const label = (k) => {
    if (gran === 'hour') { const [f, h] = k.split('|'); const p = f.split('-'); return `${p[2]}/${p[1]} ${String(h).padStart(2, '0')}:00`; }
    const p = k.split('-'); return `${p[2]}/${p[1]}`;
  };
  // Acumulado: venta y sesiones se suman a lo largo del período; CR = tasa acumulada (tk_acum/ses_acum).
  const run = { r: zz(), a: zz(), o: zz() };
  const rows = order.map((k) => {
    const e = acc.get(k);
    for (const gk of ['r', 'a', 'o']) { run[gk].ses += e[gk].ses; run[gk].tk += e[gk].tk; run[gk].rev += e[gk].rev; run[gk].inv += e[gk].inv; }
    const s = acum ? run : e; // fuente de la fila: acumulado o solo el bucket
    // Por bloque: 2025 · Obj · Real · vs AA (real/2025 − 1) · vs Obj (real/obj − 1, semáforo 70/100). A pedido
    // de Forus: la variación acompaña a cada KPI. 'objv' recibe el ratio y renderTable le resta 1.
    // Inversión: vs Obj con semáforo invertido ('objvi', como el % MKT del Control: pasarse del presupuesto es rojo).
    const crA = div(s.a.tk, s.a.ses), crO = div(s.o.tk, s.o.ses), crR = div(s.r.tk, s.r.ses);
    const vs = (r, b) => (r != null && b ? r / b - 1 : null), ratio = (r, b) => (r != null && b ? r / b : null);
    return {
      cells: [label(k),
        z(s.a.rev / tc), z(s.o.rev / tc), z(s.r.rev / tc), vs(s.r.rev, s.a.rev), ratio(s.r.rev, s.o.rev),
        z(s.a.ses), z(s.o.ses), z(s.r.ses), vs(s.r.ses, s.a.ses), ratio(s.r.ses, s.o.ses),
        crA, crO, crR, vs(crR, crA), ratio(crR, crO),
        z(s.a.inv / tc), z(s.o.inv / tc), z(s.r.inv / tc), vs(s.r.inv, s.a.inv), ratio(s.r.inv, s.o.inv)],
      colors: { 4: 'growth', 5: 'objv', 9: 'growth', 10: 'objv', 14: 'growth', 15: 'objv', 19: 'growth', 20: 'objvi' },
    };
  });
  if (!rows.length) return null;
  const sfx = acum ? ' (acum.)' : gran === 'hour' ? ' (hora)' : ' (día)';
  return {
    groups: [{ label: '', span: 1 }, { label: 'Ingresos' + sfx, span: 5 }, { label: 'Sesiones' + sfx, span: 5 }, { label: 'Conversión' + sfx, span: 5 }, { label: 'Inversión' + sfx, span: 5 }],
    cols: [{ label: gran === 'hour' ? 'Hora' : 'Día', fmt: 'txt' },
      { label: '2025', fmt: 'usd' }, { label: 'Obj', fmt: 'usd' }, { label: 'Real', fmt: 'usd' }, { label: 'vs AA', fmt: 'pct' }, { label: 'vs Obj', fmt: 'pct' },
      { label: '2025', fmt: 'int' }, { label: 'Obj', fmt: 'int' }, { label: 'Real', fmt: 'int' }, { label: 'vs AA', fmt: 'pct' }, { label: 'vs Obj', fmt: 'pct' },
      { label: '2025', fmt: 'pct2' }, { label: 'Obj', fmt: 'pct2' }, { label: 'Real', fmt: 'pct2' }, { label: 'vs AA', fmt: 'pct' }, { label: 'vs Obj', fmt: 'pct' },
      { label: '2025', fmt: 'usd', tip: 'Inversión Google + Meta del mismo tramo de 2025.' }, { label: 'Obj', fmt: 'usd', tip: 'Presupuesto = venta objetivo de la hora × % marketing objetivo del día.' }, { label: 'Real', fmt: 'usd', tip: 'Inversión Google + Meta.' }, { label: 'vs AA', fmt: 'pct' }, { label: 'vs Obj', fmt: 'pct', tip: 'Real ÷ presupuesto − 1: + = se gastó de más. Verde en o bajo presupuesto.' }],
    rows,
  };
}

// Comparativo (preserva diseño: Inv/Ing fijos + Ses/CR toggleables, semáforo YoY)
const usd = (n) => (n == null ? '—' : CUR.sym + Math.round(n).toLocaleString('es-UY'));
const nf = (n) => (n == null ? '—' : Math.round(n).toLocaleString('es-UY'));
const pctf = (n) => (n == null ? '—' : (n * 100).toFixed(2) + '%');
function winLY(w) { const off = 364 * 24; return { t0: w.t0 - off, t1: w.t1 - off }; }
function sumBrand(rows, w, m, isAds) {
  const o = { inv: 0, ses: 0, tk: 0, rev: 0 };
  for (const r of rows) { if (r.m !== m) continue; if (r.t < w.t0 || r.t >= w.t1) continue; if (isAds) o.inv += r.inv; else { o.ses += r.ses; o.tk += r.tk; o.rev += r.rev; } }
  return o;
}
function buildComp(D, ctx) {
  const w = ctx.w, wl = winLY(w), tc = ctx.tc, out = [];
  for (const m of D.brands) {
    const a = sumBrand(D.ads, w, m, true).inv / tc, aL = sumBrand(D.ads, wl, m, true).inv / tc; // inv UYU interno → /tc display
    const s = sumBrand(D.shop, w, m, false), sL = sumBrand(D.shop, wl, m, false);
    out.push([m, a, aL, s.rev / tc, sL.rev / tc, s.ses, sL.ses, s.ses ? s.tk / s.ses : null, sL.ses ? sL.tk / sL.ses : null]);
  }
  return out;
}
function renderComp(D, ctx, showSes, showCr) {
  const COMP = buildComp(D, ctx);
  const blocks = HIDE_INV ? [] : [['Inversión', 1, 2, usd, false, false]];
  blocks.push(['Ingresos', 3, 4, usd, false, true]);
  if (showSes) blocks.push(['Sesiones', 5, 6, nf, false, true]);
  if (showCr) blocks.push(['Conversión', 7, 8, null, true, true]);
  let g = '<table class="fev-sticky"><thead><tr class="fev-grp"><th rowspan="2">Marca</th>';
  blocks.forEach((b, i) => { g += `<th colspan="4" class="${i > 0 ? 'fev-bs' : ''}">${b[0]}</th>`; });
  g += '</tr><tr>';
  blocks.forEach((b, i) => { g += `<th class="${i > 0 ? 'fev-bs' : ''}">2026</th><th>2025</th><th>%</th><th>${b[4] ? 'Dif pp' : 'Dif'}</th>`; });
  g += '</tr></thead><tbody>';
  const cells = (r, b, i) => {
    const v26 = r[b[1]], v25 = r[b[2]], isCr = b[4];
    const val26 = isCr ? pctf(v26) : b[3](v26), val25 = isCr ? pctf(v25) : b[3](v25);
    const grow = v25 ? v26 / v25 - 1 : null; // % de crecimiento YoY (ej. 29k vs 23k → +26%), no el ratio
    const pctCell = grow == null ? '—' : `<span class="${grow >= 0 ? 'fev-pos' : 'fev-neg'}">${grow >= 0 ? '+' : ''}${Math.round(grow * 100)}%</span>`;
    const dif = (v26 || 0) - (v25 || 0);
    const difCell = isCr
      ? `<span class="${dif >= 0 ? 'fev-pos' : 'fev-neg'}">${dif >= 0 ? '+' : ''}${(dif * 100).toFixed(2)} pp</span>`
      : `<span class="${dif >= 0 ? 'fev-pos' : 'fev-neg'}">${dif >= 0 ? '+' : '−'}${b[3] === nf ? nf(Math.abs(dif)) : CUR.sym + Math.round(Math.abs(dif)).toLocaleString('es-UY')}</span>`;
    return `<td class="${i > 0 ? 'fev-bs' : ''}">${val26}</td><td>${val25}</td><td>${pctCell}</td><td>${difCell}</td>`;
  };
  COMP.forEach((r) => { g += `<tr><td class="fev-rh">${r[0]}</td>` + blocks.map((b, i) => cells(r, b, i)).join('') + '</tr>'; });
  const T = ['Total']; for (let k = 1; k <= 6; k++) T[k] = COMP.reduce((a, r) => a + (r[k] || 0), 0);
  const sw = COMP.reduce((a, r) => a + r[5], 0), swl = COMP.reduce((a, r) => a + r[6], 0);
  T[7] = sw ? COMP.reduce((a, r) => a + (r[7] || 0) * r[5], 0) / sw : null;
  T[8] = swl ? COMP.reduce((a, r) => a + (r[8] || 0) * r[6], 0) / swl : null;
  g += '</tbody><tfoot><tr><td>Total</td>' + blocks.map((b, i) => cells(T, b, i)).join('') + '</tr></tfoot></table>';
  return g;
}

// Tabla principal de Control, reordenada a pedido de Forus: Venta · Conversión · Inversión · %MKT ·
// Venta paid · Tráfico. Se arma desde las celdas de FX.tablaMarcas (por índice original), sin las
// columnas GA4. Todos los "% objetivo" se muestran como VARIACIÓN (real ÷ objetivo − 1: −20% en vez de
// 80%), a pedido de Forus; el color sigue siendo semáforo 70/100 sobre el ratio. En %MKT (menos es
// mejor) el semáforo va invertido. Venta ya viene sin IVA (buildSrc).
function buildControlMarcas(tm) {
  const rows = tm.rows.map((r) => {
    const c = r.cells, label = c[0];
    // El motor ya trae, ponderado por día (y por eso válido en cualquier ventana o rango personalizado,
    // y en la fila total): c[17]=inversión real, c[18]=presupuesto (Σ venta obj × %mkt obj del día),
    // c[19]=% presupuesto (inv real ÷ presupuesto), c[20]=%mkt real (inv ÷ venta). El %mkt objetivo =
    // presupuesto ÷ venta objetivo = blend ponderado por la venta de cada día (ratio neutral a la moneda).
    const actual = c[20];
    const presup = c[18] || null;
    const objMkt = c[13] ? c[18] / c[13] : null;
    const pctObj = objMkt && actual ? actual / objMkt : null;       // real/obj: se muestra −1 (+ = gastó de más), color invertido
    return {
      cls: r.cls,
      cells: [label,
        c[11], c[13], c[14], c[15], c[16],   // Venta: venta, objetivo, %obj, AA, %vsAA
        c[7], c[9], c[10],                   // Conversión: CR, CR obj, CR AA
        c[17], presup, c[19], c[21], c[22],  // Inversión: inversión, presupuesto, %presupuesto, año anterior, %vsAA
        actual, objMkt, pctObj,              // %MKT: actual, objetivo, % objetivo (variación, semáforo invertido)
        c[23], c[24],                        // Venta paid: venta atribuida a Google+Meta, % sobre la venta total
        c[1], c[3], c[4], c[5], c[6]],       // Tráfico: sesiones, objetivo, %obj, AA, %vsAA
      colors: { 3: 'objv', 5: 'growth', 13: 'growth', 16: 'objvi', 21: 'objv', 23: 'growth' },
    };
  });
  return {
    groups: [{ label: '', span: 1 }, { label: 'Venta', span: 5 }, { label: 'Conversión', span: 3 },
      { label: 'Inversión', span: 5 }, { label: '% marketing', span: 3 }, { label: 'Venta paid', span: 2 }, { label: 'Tráfico', span: 5 }],
    cols: [{ label: 'Marca', fmt: 'txt' },
      { label: 'Venta', fmt: 'usd', tip: 'Venta real del período, SIN IVA y neta del descuento Santander (se descuenta el % de la marca/período sobre el 95% de la venta). Fuente: Shopify.' },
      { label: 'Objetivo', fmt: 'usd', tip: 'Meta de venta del plan de la campaña, SIN IVA y sin descuento Santander. Cargada para Pre / Cyber / Extendido.' },
      { label: '% objetivo', fmt: 'pct', tip: 'Variación de la venta real vs objetivo (real ÷ objetivo − 1). Color semáforo: verde ≥ objetivo, amarillo 70-99 %, rojo <70 %.' },
      { label: 'Año anterior', fmt: 'usd', tip: 'Venta del mismo tramo de 2025 (−364 días), SIN IVA y SIN descuento. Del 30/10 al 10/11 de 2025 es la venta hora por hora del Excel de Forus; fuera de esas fechas, GA4 (Mango: Shopify).' },
      { label: '% vs AA', fmt: 'pct', tip: 'Crecimiento de la venta vs 2025 (real ÷ año anterior − 1). Da algo más bajo a propósito: 2026 va neto de Santander y 2025 bruto.' },
      { label: 'CR', fmt: 'pct2', tip: 'Tasa de conversión = Tickets ÷ Sesiones del período. Fuente: Shopify.' },
      { label: 'CR objetivo', fmt: 'pct2', tip: 'El objetivo de conversión = mantener el CR del año anterior (CR 2025).' },
      { label: 'CR año anterior', fmt: 'pct2', tip: 'Tickets ÷ Sesiones del mismo tramo de 2025.' },
      { label: 'Inversión', fmt: 'usd', tip: 'Gasto en medios del período (Google + Meta), en la moneda del selector (USD/UYU).' },
      { label: 'Presupuesto', fmt: 'usd', tip: 'Inversión objetivo = Venta objetivo × % marketing objetivo. Aparece donde hay venta objetivo cargada.' },
      { label: '% presupuesto', fmt: 'pct', tip: 'Inversión real ÷ Presupuesto (cuánto del presupuesto se consumió).' },
      { label: 'Año anterior', fmt: 'usd', tip: 'Inversión del mismo tramo de 2025 (Google + Meta, cuentas activas).' },
      { label: '% vs AA', fmt: 'pct', tip: 'Crecimiento de la inversión vs 2025 (real ÷ año anterior − 1).' },
      { label: '% MKT', fmt: 'pct2', tip: 'Inversión ÷ Venta del período (sin IVA): cuánto de la venta se gastó en medios.' },
      { label: 'Objetivo', fmt: 'pct2', tip: 'Meta de % marketing (inversión ÷ venta sin IVA). Se calcula por día según el evento (Pre/Cyber/Extendido/Black; si no hay objetivo propio o no es día de evento, Resto de mes) y se pondera por la venta objetivo de cada día. Un rango que cruza eventos da el % combinado.' },
      { label: '% objetivo', fmt: 'pct', tip: 'Variación del % MKT real vs objetivo (real ÷ objetivo − 1): +20 % = se gastó un 20 % más de lo previsto sobre la venta. Semáforo INVERTIDO (menor es mejor): verde = en o por debajo del objetivo, amarillo hasta +43 %, rojo más.' },
      { label: 'Venta paid', fmt: 'usd', tip: 'Venta atribuida a medios pagos (Google + Meta) por último clic de Shopify, SIN IVA y neta de Santander. Misma base que el ROAS de medios pagos.' },
      { label: '% paid', fmt: 'pct', tip: 'Peso de la venta paid sobre la venta total del período (venta paid ÷ venta).' },
      { label: 'Sesiones', fmt: 'int', tip: 'Sesiones del período. Fuente: Shopify.' },
      { label: 'Objetivo', fmt: 'int', tip: 'Sesiones del año anterior × (1 + crecimiento del Excel).' },
      { label: '% objetivo', fmt: 'pct', tip: 'Variación de sesiones reales vs objetivo (real ÷ objetivo − 1). Color semáforo: verde ≥ objetivo, amarillo 70-99 %, rojo <70 %.' },
      { label: 'Año anterior', fmt: 'int', tip: 'Sesiones del mismo tramo de 2025.' },
      { label: '% vs AA', fmt: 'pct', tip: 'Crecimiento de sesiones vs 2025 (real ÷ año anterior − 1).' }],
    rows,
  };
}

// Tráfico con utm que NO matcheó ninguna regla del conector (canal 'otro'): emails, afiliados, promos…
// pero también cualquier campaña paga con nombre nuevo que el clasificador no reconoció. Se muestra para
// que no quede invisible (caso "S l Branding" 30/10): si acá aparece algo que es pago, se corrige el nombre
// o la regla. Lee raw.shopify (buildSrc convierte 'otro' a directo y pierde el utm). Venta SIN IVA.
function buildSinClasificar(raw, ctx, brand) {
  const FX = window.FX, acc = new Map();
  for (const r of raw.shopify) {
    if (r.canal !== 'otro' || (brand && r.marca !== brand)) continue;
    const t = FX.dayIdx(r.fecha) * 24 + (+r.hora || 0);
    if (t < ctx.w.t0 || t >= ctx.w.t1) continue;
    const k = r.tipo_campana || '(sin nombre)';
    const e = acc.get(k) || { ses: 0, tk: 0, rev: 0 };
    e.ses += r.sesiones || 0; e.tk += r.tickets || 0; e.rev += (r.ingresos_uyu || 0) - (r.iva_uyu || 0); acc.set(k, e);
  }
  if (!acc.size) return null;
  const rows = [...acc.entries()].sort((a, b) => b[1].ses - a[1].ses).slice(0, 20)
    .map(([k, e]) => ({ cells: [k, e.ses, e.tk, e.rev / ctx.tc] }));
  return { cols: [{ label: 'utm_campaign', fmt: 'txt' }, { label: 'Sesiones', fmt: 'int' }, { label: 'Tickets', fmt: 'int' }, { label: 'Ingresos', fmt: 'usd' }], rows };
}

function hourlyVenta(D, brand, dayIdx, tc) {
  const out = new Array(24).fill(0);
  for (const r of D.shop) { if (r.d !== dayIdx) continue; if (brand !== 'Todas las marcas' && r.m !== brand) continue; const h = r.t - r.d * 24; if (h >= 0 && h < 24) out[h] += r.rev / tc; }
  return out;
}
function buildProy(D, ctx, brand, proyDate, proyCompare) {
  const FX = window.FX;
  const cutDay = FX.dayIdx(proyDate), compareDay = FX.dayIdx(proyCompare);
  // corte = última hora con data en el día elegido (+1); día completo → 24, sin data → 0
  let maxH = -1;
  for (const r of D.shop) { if (r.d !== cutDay) continue; if (brand !== 'Todas las marcas' && r.m !== brand) continue; const hh = r.t - r.d * 24; if (hh > maxH) maxH = hh; }
  const corte = maxH < 0 ? 0 : Math.min(24, maxH + 1);
  const ci = corte - 1;
  const ly = hourlyVenta(D, brand, compareDay, ctx.tc);
  const today = hourlyVenta(D, brand, cutDay, ctx.tc).slice(0, corte);
  const W = 920, H = 360, pL = 58, pR = 18, pT = 16, pB = 34;
  const cum = (a) => { let s = 0; return a.map((v) => (s += v)); };
  const cumLY = cum(ly), cumT = cum(today);
  const base = ci >= 0 ? (cumT[ci] || 0) : 0, ratio = ci >= 0 && cumLY[ci] ? base / cumLY[ci] : 1;
  const proj = ly.map((_, h) => (ci < 0 || h < ci ? null : h === ci ? base : base + (cumLY[h] - cumLY[ci]) * ratio));
  const maxV = Math.max(cumLY[23] || 0, proj[23] || 0, base, 1);
  const X = (h) => pL + (h / 23) * (W - pL - pR), Y = (v) => H - pB - (v / maxV) * (H - pT - pB);
  const path = (arr) => arr.map((v, i) => (v == null ? null : `${i === 0 || arr[i - 1] == null ? 'M' : 'L'}${X(i).toFixed(1)} ${Y(v).toFixed(1)}`)).filter(Boolean).join(' ');
  let g = '';
  for (let i = 0; i <= 4; i++) { const v = (maxV * i) / 4, y = Y(v); g += `<line x1="${pL}" y1="${y.toFixed(1)}" x2="${W - pR}" y2="${y.toFixed(1)}" stroke="#ECEDF5"/><text x="${pL - 8}" y="${(y + 4).toFixed(1)}" text-anchor="end" font-family="IBM Plex Mono" font-size="10" fill="#9094AE">$${Math.round(v)}</text>`; }
  for (let h = 0; h <= 23; h += 3) g += `<text x="${X(h).toFixed(1)}" y="${H - 12}" text-anchor="middle" font-family="IBM Plex Mono" font-size="10" fill="#9094AE">${h}h</text>`;
  if (corte > 0) g += `<polygon points="${X(0)},${Y(0)} ${cumT.map((v, i) => X(i).toFixed(1) + ',' + Y(v).toFixed(1)).join(' ')} ${X(ci)},${Y(0)}" fill="rgba(27,61,251,.06)"/>`;
  g += `<path d="${path(cumLY)}" fill="none" stroke="#9094AE" stroke-width="2"/>`;
  g += `<path d="${path(proj)}" fill="none" stroke="#4D66FF" stroke-width="2" stroke-dasharray="5 4"/>`;
  g += `<path d="${path(cumT)}" fill="none" stroke="#1B3DFB" stroke-width="2.5"/>`;
  g += `<line class="fev-pg" x1="0" y1="${pT}" x2="0" y2="${H - pB}" stroke="#C9CEE6" stroke-dasharray="3 3" style="opacity:0"/>`;
  g += `<circle class="fev-pdL" r="4" fill="#9094AE" style="opacity:0"/><circle class="fev-pd2" r="4.5" fill="#1B3DFB" style="opacity:0"/>`;
  // Cajitas: acumulado a la hora de corte, 2026 vs 2025 (para entender el porqué de la curva)
  const agg = (dIdx) => {
    let s = 0, tk = 0, rev = 0;
    for (const r of D.shop) { if (r.d !== dIdx) continue; if (brand !== 'Todas las marcas' && r.m !== brand) continue; const hh = r.t - r.d * 24; if (hh >= 0 && hh < corte) { s += r.ses; tk += r.tk; rev += r.rev; } }
    return { ses: s, ing: rev / ctx.tc, cr: s ? tk / s : null };
  };
  const a26 = agg(cutDay), a25 = agg(compareDay);
  const grow = (a, b) => (b ? Math.round((a / b - 1) * 100) : null);
  const sg = (x) => (x == null ? '—' : (x >= 0 ? '+' : '') + x + '%');
  const boxes = [
    ['Sesiones', Math.round(a26.ses).toLocaleString('es-UY'), a25.ses ? Math.round(a25.ses).toLocaleString('es-UY') : '—', grow(a26.ses, a25.ses)],
    ['Venta', CUR.sym + Math.round(a26.ing).toLocaleString('es-UY'), a25.ing ? CUR.sym + Math.round(a25.ing).toLocaleString('es-UY') : '—', grow(a26.ing, a25.ing)],
    ['Conversión', a26.cr == null ? '—' : (a26.cr * 100).toFixed(2) + '%', a25.cr == null ? '—' : (a25.cr * 100).toFixed(2) + '%', grow(a26.cr, a25.cr)],
  ].map((b) => [b[0], b[1], `${b[2]} comparación`, sg(b[3]), b[3] == null ? '' : b[3] >= 0 ? 'fev-pos' : 'fev-neg']);
  return { svg: g, state: { cumLY, cumT, proj, X, Y, W, pL, pR, corte }, boxes };
}

export default function ForusEventsPanel() {
  const [raw, setRaw] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | ok | error | empty
  const [group, setGroup] = useState('control');
  const [brand, setBrand] = useState('Todas las marcas');
  const [period, setPeriod] = useState('MTD');
  const [cur, setCur] = useState('USD'); // moneda de display: USD o UYU (×41)
  const [showSes, setShowSes] = useState(true);
  const [showCr, setShowCr] = useState(true);
  const [proyDate, setProyDate] = useState('2026-10-27');
  const [proyCompare, setProyCompare] = useState(() => shiftDays('2026-10-27', -364));
  const [objGran, setObjGran] = useState('full'); // full | day | hour (sub-selección de Objetivos)
  const [objAcum, setObjAcum] = useState(true);   // detalle de Objetivos: acumulado (true) o bucket a bucket (false)
  const [customDesde, setCustomDesde] = useState(() => shiftDays(nowCorte().fecha, -7)); // período Personalizado
  const [customHasta, setCustomHasta] = useState(() => nowCorte().fecha);
  const [lastFetch, setLastFetch] = useState(null);
  const rootRef = useRef(null);
  const proyRef = useRef(null);
  const { auth } = useAuth();
  // Usuario "comercial" de Forus: no ve nada relacionado a inversión ni % marketing (ver NO_INV_USERS).
  const hideInv = NO_INV_USERS.includes(((auth?.user?.email || '').split('@')[0] || '').trim().toLowerCase());

  // Admin (equipo espor.ai): el endpoint se ata a la org del usuario, y la de un admin no es Forus →
  // se pide explícitamente la org de Forus. Para un usuario de Forus el backend ignora el parámetro.
  const orgId = auth?.user?.is_admin ? FORUS_ORG_ID : undefined;

  // silent=true: refresco en background (no muestra "Cargando…" ni pisa la vista si falla)
  const load = useCallback((silent) => {
    if (!silent) setStatus('loading');
    forusEventsApi
      .getHourly(FETCH_DESDE, FETCH_HASTA, orgId)
      .then((d) => {
        if (!d || !d.shopify) { if (!silent) setStatus('error'); return; }
        setRaw(d);
        setLastFetch(new Date());
        setStatus((d.shopify.length || d.ads.length) ? 'ok' : 'empty');
      })
      .catch(() => { if (!silent) setStatus('error'); });
  }, [orgId]);

  useEffect(() => { load(false); }, [load]);

  // Auto-refresco cada 2 min + al volver a la pestaña → data "en vivo" sin recargar.
  useEffect(() => {
    const id = setInterval(() => load(true), 120000);
    const onVis = () => { if (document.visibilityState === 'visible') load(true); };
    document.addEventListener('visibilitychange', onVis);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVis); };
  }, [load]);

  const D = useMemo(() => {
    if (!raw || !window.FX) return null;
    const d = window.FX.prep(buildSrc(raw, NORM_TC)); // normalización fija a UYU; la moneda de display es aparte
    d.brands = [...d.brands].sort((a, b) => a.localeCompare(b, 'es')); // marcas A-Z en todo el panel
    return d;
  }, [raw]);
  const brands = useMemo(() => (D ? ['Todas las marcas', ...D.brands] : ['Todas las marcas']), [D]);

  const view = useMemo(() => {
    if (!D || !window.FX) return null;
    const FX = window.FX;
    const p = periodWin(period, customDesde, customHasta);
    const cc = nowCorte();
    CUR = cur === 'UYU' ? { sym: '$U', tc: 1 } : { sym: '$', tc: NORM_TC }; // moneda de display
    HIDE_INV = hideInv; // usuario sin inversión/% mkt
    const dispTc = CUR.tc;
    const ctx = FX.contexto(D, { desde: p.desde, hasta: p.hasta, corte_fecha: cc.fecha, corte_hora: cc.hora, tc: dispTc });
    const Dp = D; // todas las marcas en la ventana del período
    if (group === 'control') {
      const tm = FX.tablaMarcas(Dp, ctx);
      const t = tm.rows.at(-1).cells, pf = FX.tablaPlataformas(Dp, ctx, null).rows.at(-1).cells;
      const kp = [
        ['Venta del período', CUR.sym + Math.round(t[11]).toLocaleString('es-UY'), '8 marcas · ' + (cur === 'UYU' ? 'UYU' : 'USD')],
        ['vs año anterior', t[16] == null ? '—' : (t[16] >= 0 ? '+' : '') + Math.round(t[16] * 100) + '%', 'mismo tramo 2025'],
        ['Sesiones', Math.round(t[1]).toLocaleString('es-UY'), 'Shopify'],
        ['Inversión', CUR.sym + Math.round(t[17]).toLocaleString('es-UY'), 'Google + Meta'],
        ['ROAS medios pagos', pf[8] == null ? '—' : pf[8].toFixed(1) + 'x', 'venta atribuida / inv'],
      ].filter((k) => !(HIDE_INV && /inversi|roas/i.test(k[0])));
      return { kind: 'control', kpis: kp, table: renderTable(hideInvCols(buildControlMarcas(tm)), true) };
    }
    if (group === 'camp') {
      const esTotal = brand === 'Todas las marcas';
      const marcaArg = esTotal ? null : brand;        // null = agregado de todas las marcas
      const quien = esTotal ? 'Todas las marcas' : brand;
      const tt = FX.tablaTipos(Dp, ctx, marcaArg);
      const ttClean = {
        cols: tt.cols.slice(1), // sin la columna Plataforma (se infiere del tipo)
        rows: tt.rows.filter((r) => r.cls !== 'sub').map((r) => {
          const cells = r.cells.slice();
          if (!cells[1]) cells[1] = cells[0]; // fila total: su label está en la col 0
          return { ...r, cells: cells.slice(1) };
        }),
      };
      const sc = buildSinClasificar(raw, ctx, marcaArg);
      const html =
        '<p class="fev-eyebrow">Por tipo de campaña</p>' + panel(quien, '', renderTable(hideInvCols(ttClean))) +
        '<p class="fev-eyebrow">Por plataforma</p>' + panel(quien, '', renderTable(hideInvCols(FX.tablaPlataformas(Dp, ctx, marcaArg)))) +
        '<p class="fev-eyebrow">Día a día</p>' + panel(quien, 'base: pago', renderTable(hideInvCols(FX.tablaDiaria(Dp, ctx, marcaArg, 'pago')))) +
        (sc ? '<p class="fev-eyebrow">Sin clasificar</p>' + panel(quien, 'utm con tráfico que no entra en ningún tipo (no cuenta como pago)', renderTable(sc)) +
          '<div class="fev-note">Control de nombres: acá caen emails, afiliados y promos, que está bien que no sean pago. Si aparece una campaña de Google o Meta, el nombre no sigue la convención (rem/manual · ao · search/brand/"S |" · shopping · pmax · demand) y hay que renombrarla o avisar para ajustar la regla.</div>' : '');
      return { kind: 'html', html };
    }
    if (group === 'obj') {
      const quien = brand === 'Todas las marcas' ? 'Todas las marcas' : brand;
      if (objGran === 'full') {
        const to = buildObjetivosTable(Dp, ctx, brand);
        return { kind: 'html', html: panel(`Objetivos · ${quien}`, '2025 · target 2026 · real 2026', renderTable(to)) +
          '<div class="fev-note">Venta real 2026 SIN IVA y neta de descuento Santander; 2025 y target SIN IVA (sin descuento). Target = venta del Excel (PRE+CYBER+Extendido); sesiones/CR objetivo = año anterior × crecimiento. ' + (HIDE_INV ? '' : 'Inversión objetivo (presupuesto) = venta objetivo × % marketing objetivo. ') + '% objetivo = variación real vs target (real ÷ target − 1), semáforo 70/100.</div>' };
      }
      const det = buildObjDetalle(D, p, brand, objGran, dispTc, objAcum);
      const unidad = objGran === 'hour' ? 'hora' : 'día';
      const mini = (objGran === 'hour' ? 'por día y hora' : 'por día') + (objAcum ? ' · acumulado' : ` · ${unidad} x ${unidad}`) + ' · 2025 · objetivo · real';
      const nota = objAcum
        ? 'Venta y sesiones ACUMULADAS a lo largo del período; CR = tasa acumulada (no se suma).'
        : `Cada fila es SOLO ese ${unidad} (no acumula): sirve para ver si cada ${unidad} del evento viene en verde o rojo.`;
      return { kind: 'html', html: panel(`Objetivos · ${quien}`, mini, renderTable(hideInvCols(det), true)) +
        `<div class="fev-note">${nota} Objetivo de venta por hora (Excel); sesiones/CR objetivo = año anterior × crecimiento${HIDE_INV ? '' : '; inversión objetivo = venta objetivo de la hora × % marketing objetivo del día (Google + Meta)'}. vs AA = real ÷ 2025 − 1; vs Obj = real ÷ objetivo − 1 (semáforo: verde ≥ objetivo, amarillo 70-99 %, rojo <70 %${HIDE_INV ? '' : '; en Inversión al revés: verde en o bajo presupuesto'}).</div>` };
    }
    if (group === 'comp') return { kind: 'html', html: panel('Marcas · 2026 vs 2025', '', renderComp(Dp, ctx, showSes, showCr)) };
    if (group === 'proy') { const pr = buildProy(D, ctx, brand, proyDate, proyCompare); proyRef.current = pr.state; return { kind: 'proy', svg: pr.svg, boxes: pr.boxes, corte: pr.state.corte }; }
    return null;
  }, [D, raw, group, brand, period, cur, showSes, showCr, proyDate, proyCompare, objGran, objAcum, customDesde, customHasta, hideInv]);

  // Hover de la proyección
  useEffect(() => {
    if (group !== 'proy' || !rootRef.current) return;
    const box = rootRef.current.querySelector('.fev-chartbox');
    const svg = rootRef.current.querySelector('.fev-chart');
    if (!box || !svg) return;
    const q = (c) => rootRef.current.querySelector(c);
    const hide = () => { const t = q('.fev-ptip'); if (t) t.style.opacity = 0;['.fev-pg', '.fev-pdL', '.fev-pd2'].forEach((c) => { const e = q(c); if (e) e.style.opacity = 0; }); };
    const move = (e) => {
      const P = proyRef.current; if (!P) return;
      const rect = svg.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right) { hide(); return; }
      const vbx = ((e.clientX - rect.left) / rect.width) * P.W;
      let h = Math.round(((vbx - P.pL) / (P.W - P.pL - P.pR)) * 23); h = Math.max(0, Math.min(23, h));
      const corte = P.corte ?? 24;
      const v26 = h < corte ? P.cumT[h] : P.proj[h], v25 = P.cumLY[h];
      const x = P.X(h);
      const gl = q('.fev-pg'); if (gl) { gl.setAttribute('x1', x); gl.setAttribute('x2', x); gl.style.opacity = 0.7; }
      const dL = q('.fev-pdL'); if (dL) { dL.setAttribute('cx', x); dL.setAttribute('cy', P.Y(v25 || 0)); dL.style.opacity = 1; }
      const d2 = q('.fev-pd2'); if (d2) { d2.setAttribute('cx', x); d2.setAttribute('cy', P.Y(v26 || 0)); d2.style.opacity = 1; }
      const bbox = box.getBoundingClientRect(), tip = q('.fev-ptip');
      if (!tip) return;
      tip.innerHTML = `<b>${h}:00</b><br><span class="fev-l26">Actual${h >= corte ? ' (proy)' : ''}:</span> ${CUR.sym}${Math.round(v26 || 0).toLocaleString('es-UY')}<br><span class="fev-l25">Comparación:</span> ${CUR.sym}${Math.round(v25 || 0).toLocaleString('es-UY')}`;
      // El tooltip va centrado (translate -50%); lo clampeo para que no se corte en los bordes del panel.
      const cx = (x / P.W) * rect.width + (rect.left - bbox.left);
      const tw = tip.offsetWidth, half = tw / 2 + 8;
      tip.style.left = Math.max(half, Math.min(bbox.width - half, cx)) + 'px';
      const ty = (P.Y(Math.max(v26 || 0, v25 || 0)) / 360) * rect.height + (rect.top - bbox.top) - 12;
      tip.style.top = Math.max(tip.offsetHeight + 4, ty) + 'px'; // no se corta arriba
      tip.style.opacity = 1;
    };
    box.addEventListener('mousemove', move);
    box.addEventListener('mouseleave', hide);
    return () => { box.removeEventListener('mousemove', move); box.removeEventListener('mouseleave', hide); };
  }, [view, group]);

  const exportAll = () => {
    if (!D || !window.XLSX_LITE) return;
    const FX = window.FX, p = periodWin(period, customDesde, customHasta), cc = nowCorte();
    CUR = cur === 'UYU' ? { sym: '$U', tc: 1 } : { sym: '$', tc: NORM_TC };
    HIDE_INV = hideInv;
    const ctx = FX.contexto(D, { desde: p.desde, hasta: p.hasta, corte_fecha: cc.fecha, corte_hora: cc.hora, tc: CUR.tc });
    const Dp = D; // todas las marcas en la ventana del período
    const stamp = (m, title) => { m = hideInvCols(m); m.title = title; m.subtitle = `${brand} · ${period} · ${p.desde} → ${p.hasta}`; return m; };
    const tabs = [stamp(dropCols(FX.tablaMarcas(Dp, ctx), [2, 8, 12]), 'Control de marcas')];
    if (brand === 'Todas las marcas') tabs.push(stamp(FX.tablaPlataformas(Dp, ctx, null), 'Plataformas (total)'));
    else {
      tabs.push(stamp(FX.tablaTipos(Dp, ctx, brand), 'Tipos ' + brand));
      tabs.push(stamp(FX.tablaPlataformas(Dp, ctx, brand), 'Plataformas ' + brand));
      tabs.push(stamp(FX.tablaDiaria(Dp, ctx, brand, 'pago'), 'Diaria ' + brand));
    }
    const bytes = window.XLSX_LITE.build(tabs);
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `Forus_${period}_${brand.replace(/ /g, '_')}.xlsx`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  };

  const subWin = periodWin(period, customDesde, customHasta);
  const sub = `${brand} · ${period} · ${subWin.desde} → ${subWin.hasta}`;
  const icon = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`;

  return (
    <div className="fev-root" ref={rootRef}>
      <aside className="fev-rail">
        <div className="fev-railin">
          {Object.entries(SEC).map(([k, s]) => (
            <button key={k} className={`fev-railbtn ${k === group ? 'fev-on' : ''}`} data-tip={s.t}
              onClick={() => setGroup(k)} dangerouslySetInnerHTML={{ __html: icon(s.svg) }} />
          ))}
        </div>
      </aside>
      <div className="fev-main">
        <div className="fev-top fev-card">
          <select className="fev-msel" value={brand} onChange={(e) => setBrand(e.target.value)}
            disabled={group === 'control' || group === 'comp'}
            title={group === 'control' || group === 'comp' ? 'Esta sección es de todas las marcas' : undefined}>
            {brands.map((b) => <option key={b}>{b}</option>)}
          </select>
          <div className="fev-pills">
            {PERIOD_KEYS.map((p) => (
              <button key={p} className={p === period ? 'fev-on' : ''} onClick={() => setPeriod(p)}>{p}</button>
            ))}
          </div>
          {period === 'Personalizado' && (
            <div className="fev-ctl">
              <input type="date" value={customDesde} onChange={(e) => setCustomDesde(e.target.value)} />
              <span>→</span>
              <input type="date" value={customHasta} onChange={(e) => setCustomHasta(e.target.value)} />
            </div>
          )}
          <div className="fev-spacer" />
          <div className="fev-pills fev-cur">
            {['USD', 'UYU'].map((c) => (
              <button key={c} className={cur === c ? 'fev-on' : ''} onClick={() => setCur(c)} title={c === 'UYU' ? 'Pesos uruguayos (TC 41)' : 'Dólares'}>{c}</button>
            ))}
          </div>
          {raw?.last_sync && (
            <span
              className="fev-updated"
              title={lastFetch ? `Panel revisado ${lastFetch.toLocaleTimeString('es-UY', { hour: '2-digit', minute: '2-digit' })}` : ''}
            >
              Sincronizado {new Date(raw.last_sync).toLocaleTimeString('es-UY', { hour: '2-digit', minute: '2-digit' })}
            </span>
          )}
          <button className="fev-iconbtn" title="Actualizar ahora" onClick={() => load(true)}
            dangerouslySetInnerHTML={{ __html: icon('<path d="M21 12a9 9 0 1 1-2.64-6.36"/><polyline points="21 3 21 9 15 9"/>') }} />
          <button className="fev-iconbtn fev-pri" title="Descargar todas las tablas" onClick={exportAll}
            dangerouslySetInnerHTML={{ __html: icon('<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>') }} />
        </div>

        {status === 'loading' && <div className="fev-state">Cargando datos…</div>}
        {status === 'error' && <div className="fev-state">No se pudo cargar el panel. Probá de nuevo en unos segundos.</div>}
        {status === 'empty' && <div className="fev-state">Todavía no hay datos cargados para tu organización.</div>}

        {status === 'ok' && view && (
          <div className="fev-wrap">
            {group === 'control' && <div className="fev-shead"><div><h2>Control general</h2><div className="fev-sub">{sub}</div></div></div>}
            {group === 'obj' && (
              <div className="fev-shead">
                <div><h2>Objetivos</h2><div className="fev-sub">{sub}</div></div>
                <div className="fev-toggles">
                  {objGran !== 'full' && (
                    <div className="fev-pills">
                      {[[true, 'Acumulado'], [false, objGran === 'hour' ? 'Hora x hora' : 'Día x día']].map(([k, t]) => (
                        <button key={t} className={objAcum === k ? 'fev-on' : ''} onClick={() => setObjAcum(k)}>{t}</button>
                      ))}
                    </div>
                  )}
                  <div className="fev-pills">
                    {[['full', 'Completo'], ['day', 'Por día'], ['hour', 'Día y hora']].map(([k, t]) => (
                      <button key={k} className={objGran === k ? 'fev-on' : ''} onClick={() => setObjGran(k)}>{t}</button>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {group === 'camp' && <div className="fev-shead"><div><h2>Campañas y plataformas</h2><div className="fev-sub">{sub}</div></div></div>}
            {group === 'comp' && (
              <div className="fev-shead">
                <div><h2>Comparativo</h2><div className="fev-sub">{sub}</div></div>
                <div className="fev-toggles">
                  <button className={`fev-tgl ${showSes ? 'fev-on' : ''}`} onClick={() => setShowSes((v) => !v)}>Sesiones</button>
                  <button className={`fev-tgl ${showCr ? 'fev-on' : ''}`} onClick={() => setShowCr((v) => !v)}>Conversión</button>
                </div>
              </div>
            )}
            {group === 'proy' && (
              <div className="fev-shead">
                <div><h2>Proyección</h2><div className="fev-sub">{brand === 'Todas las marcas' ? 'Todas las marcas' : brand} · 1 día vs 1 día</div></div>
                <div className="fev-toggles">
                  <label className="fev-ctl">Fecha <input type="date" value={proyDate} onChange={(e) => setProyDate(e.target.value)} /></label>
                  <label className="fev-ctl">Comparar <input type="date" value={proyCompare} onChange={(e) => setProyCompare(e.target.value)} /></label>
                </div>
              </div>
            )}

            {view.kind === 'control' && (
              <>
                <div className={`fev-kpis${view.kpis.length <= 3 ? ' fev-k3' : ''}`}>
                  {view.kpis.map((c, i) => (
                    <div className="fev-kpi fev-card" key={i}><div className="fev-l">{c[0]}</div><div className="fev-v">{c[1]}</div><div className="fev-s">{c[2]}</div></div>
                  ))}
                </div>
                <div className="fev-legend">
                  <span><i style={{ background: 'var(--fev-ok)' }} />≥100% objetivo</span>
                  <span><i style={{ background: 'var(--fev-warn)' }} />70–99%</span>
                  <span><i style={{ background: 'var(--fev-bad)' }} />&lt;70%</span>
                </div>
                <div dangerouslySetInnerHTML={{ __html: panel('Control de marcas', (hideInv ? 'venta · conversión · venta paid · tráfico' : 'venta · conversión · inversión · % mkt · venta paid · tráfico') + ' — vs objetivo y año anterior', view.table) }} />
                <div className="fev-note">Pasá el mouse por el encabezado de cada métrica para ver cómo se compone. Venta real 2026 SIN IVA (con envío) y neta de descuento Santander; 2025 sin descuento. Data real (Shopify + Google + Meta). El año anterior y el objetivo se cortan a la misma hora/día que el período en curso (comparación justa hasta el corte).</div>
              </>
            )}
            {view.kind === 'html' && <div dangerouslySetInnerHTML={{ __html: view.html }} />}
            {view.kind === 'proy' && (<>
              <div className="fev-kpis3">
                {view.boxes.map((b, i) => (
                  <div className="fev-kpi fev-card" key={i}>
                    <div className="fev-l">{b[0]} acumulado · corte {view.corte}:00</div>
                    <div className="fev-v">{b[1]}</div>
                    <div className="fev-s">{b[2]} · <span className={b[4]}>{b[3]}</span></div>
                  </div>
                ))}
              </div>
              <div className="fev-panel fev-card">
                <div className="fev-phead"><h3>Venta acumulada por hora — {brand === 'Todas las marcas' ? 'Todas' : brand}</h3><span className="fev-mini">{proyDate} vs {proyCompare} · corte {view.corte}:00</span></div>
                <div className="fev-legend" style={{ margin: '14px 22px 0' }}>
                  <span><i className="fev-ln" style={{ borderTop: '2px solid var(--fev-slate-2)' }} />Comparación ({proyCompare})</span>
                  <span><i className="fev-ln" style={{ borderTop: '2px solid var(--fev-blue)' }} />Actual ({proyDate})</span>
                  <span><i className="fev-ln" style={{ borderTop: '2px dashed var(--fev-blue-soft)' }} />Proyección</span>
                </div>
                <div className="fev-chartbox">
                  <svg className="fev-chart" viewBox="0 0 920 360" preserveAspectRatio="xMidYMid meet" dangerouslySetInnerHTML={{ __html: view.svg }} />
                  <div className="fev-ptip" />
                </div>
              </div>
            </>)}
          </div>
        )}
      </div>
    </div>
  );
}
